import {
  listCustomFieldSuggestions as publicListCustomFieldSuggestions,
  queryCustomFieldSuggestions as publicQueryCustomFieldSuggestions,
  typedQueryCustomFieldSuggestions as publicTypedQueryCustomFieldSuggestions,
} from './members-v1-custom-field-suggestion-custom-field-suggestions.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  CustomFieldSuggestionQuery,
  SuggestionsQueryBuilder,
  typedQueryCustomFieldSuggestions as universalTypedQueryCustomFieldSuggestions,
} from './members-v1-custom-field-suggestion-custom-field-suggestions.universal.js';

function customQueryCustomFieldSuggestions(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryCustomFieldSuggestions(httpClient)(),
    typedQueryFunction: (query: CustomFieldSuggestionQuery) =>
      publicTypedQueryCustomFieldSuggestions(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): SuggestionsQueryBuilder;
  function overloadedQuery(
    query: CustomFieldSuggestionQuery
  ): ReturnType<typeof universalTypedQueryCustomFieldSuggestions>;
  function overloadedQuery(query?: CustomFieldSuggestionQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const listCustomFieldSuggestions: MaybeContext<
  BuildRESTFunction<typeof publicListCustomFieldSuggestions> &
    typeof publicListCustomFieldSuggestions
> = /*#__PURE__*/ createRESTModule(publicListCustomFieldSuggestions);
export const queryCustomFieldSuggestions: MaybeContext<
  BuildRESTFunction<typeof customQueryCustomFieldSuggestions> &
    typeof customQueryCustomFieldSuggestions
> = /*#__PURE__*/ createRESTModule(customQueryCustomFieldSuggestions);

export {
  Privacy,
  Type,
  SocialTypeType,
  Origin,
  SortOrder,
} from './members-v1-custom-field-suggestion-custom-field-suggestions.universal.js';
export {
  CustomFieldSuggestion,
  ListCustomFieldSuggestionsRequest,
  Paging,
  Sorting,
  ListCustomFieldSuggestionsResponse,
  PagingMetadata,
  QueryCustomFieldSuggestionsRequest,
  Query,
  QueryCustomFieldSuggestionsResponse,
  ListCustomFieldSuggestionsOptions,
  SuggestionsQueryResult,
  SuggestionsQueryBuilder,
  CustomFieldSuggestionQuerySpec,
} from './members-v1-custom-field-suggestion-custom-field-suggestions.universal.js';
export { utils } from './members-v1-custom-field-suggestion-custom-field-suggestions.universal.js';
export {
  PrivacyWithLiterals,
  TypeWithLiterals,
  SocialTypeTypeWithLiterals,
  OriginWithLiterals,
  SortOrderWithLiterals,
  CommonQueryWithEntityContext,
  CustomFieldSuggestionQuery,
} from './members-v1-custom-field-suggestion-custom-field-suggestions.universal.js';
